import { Injectable, NgZone } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, map, auditTime } from 'rxjs/operators';
import { ModernBreakpoints, ALL_BREAKPOINTS, AppScreen } from './responsive.breakpoints';

@Injectable({ providedIn: 'root' })
export class ResponsiveService {
  private readonly _screen$ = new BehaviorSubject<AppScreen | null>(null);
  readonly screen$ = this._screen$.asObservable();

  constructor(private bp: BreakpointObserver, private zone: NgZone) {
    this.bp
      .observe(ALL_BREAKPOINTS)
      .pipe(
        auditTime(0), // regroupe les notifications de resize
        map((state: BreakpointState) => this.pickScreen(state.breakpoints)),
        distinctUntilChanged()
      )
      .subscribe((screen) => {
        this.zone.run(() => this._screen$.next(screen));
      });
  }

  private pickScreen(b: Record<string, boolean>): AppScreen {
    // on retourne le premier qui matche
    for (const [screen, query] of Object.entries(ModernBreakpoints)) {
      if (b[query]) return screen as AppScreen;
    }
    // fallback : si rien ne matche (ex. <360px), on considère MobileSmall
    return AppScreen.MobileSmall;
  }
}
